import { userInfoSync } from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
import { ALL_GATES, loadGates } from '../constants/gates';
export const resetGatesCache = () => ALL_GATES.splice(0);
export const fetchAllGates = () => {
  const userInfo = userInfoSync();
  loadGates(userInfo.gates);
};
export const hasModalDismissalGate = () => {
  if (ALL_GATES.length === 0) {
    fetchAllGates();
  }
  return ALL_GATES.includes('GrowthModals:PortalUserDismissal');
};
export const hasCopilotHookPromptGate = () => {
  if (ALL_GATES.length === 0) {
    fetchAllGates();
  }
  return ALL_GATES.includes(gate('HiC:CopilotHookPrompt'));
};